import { apiFetch } from "@/lib/api";
import type { SearchHit, SearchResults } from "./types";

interface Envelope<T> {
  success: boolean;
  message: string;
  data: T;
}

interface ApiHit {
  type: string;
  id: string;
  title: string;
  subtitle: string;
  client_id: string | null;
}

type ApiResults = Record<keyof SearchResults, ApiHit[]>;

function toHit(h: ApiHit): SearchHit {
  return {
    type: h.type as SearchHit["type"],
    id: h.id,
    title: h.title,
    subtitle: h.subtitle ?? "",
    clientId: h.client_id ?? null,
  };
}

/** GET /search/?q= — firm-wide results grouped by entity type. */
export async function globalSearch(q: string): Promise<SearchResults> {
  const body = await apiFetch<Envelope<ApiResults>>(
    `/search/?q=${encodeURIComponent(q)}`,
  );
  const d = body.data;
  return {
    clients: d.clients.map(toHit),
    documents: d.documents.map(toHit),
    cases: d.cases.map(toHit),
    invoices: d.invoices.map(toHit),
    notices: d.notices.map(toHit),
    practitioners: d.practitioners.map(toHit),
    kb: d.kb.map(toHit),
  };
}
